
<div
  v-if="content && salle"
  :class="[jel_getClassObject(content)]"
  :data-component-name="$options.name"
  class="bingo_div_height"
>
  <!-- ****************************** -->
  <!-- ***** PASTILLE (accueil) ***** -->
  <!-- ****************************** -->
  <div v-if="content.typeAffichage.field === 'pastille'" data-component-page="salles.accueil">
    <a
      :class="[isSalleActive ? 'cursor_pointer' : '']"
      @click="[isSalleActive ? launchBingoAndGaq() : '']"
    >
      <div
        class="column"
        :class="[
          isSalleActive
            ? 'ctn-shadow bingo_card_corner bingo_card_background glow_card'
            : 'bingo_card_corner bingo_salle_fermer bingo_card_background',
        ]"
      >
        <!-- Titre -->
        <div v-if="isSalleActive" class="bingo_titre bingo_color pr-4">{{ salle.titre }}</div>
        <div v-else class="bingo_titre bingo_fermer_titre_img bingo_color pr-4">
          {{ salle.titre }}
        </div>

        <div v-if="isSalleActive" class="bingo_div_img_principal">
          <b-card-img-lazy
            :src="jel_getFichierSrc(salle.image)"
            :alt="salle.titre"
            :data-tag="`${jel_getNomRouteCourante()} - ${salle.titre.replace(/&nbsp;/g, ' ')} - ${
              content.dataTag
            }`"
            class="bingo_img_principal"
          ></b-card-img-lazy>
          <div class="position-relative bingo_container_over_price">
            <div class="bingo_container_over graphik_bold">
              <money-format
                :value="salleLive.prixCarteMin"
                :locale="$i18n.locale + '-CA'"
                currency-code="CAD"
                :subunit-value="true"
              ></money-format>
              <span v-if="salleLive.prixCarteMin != salleLive.prixCarteMax" class="px-1">
                -
              </span>
              <money-format
                v-if="salleLive.prixCarteMin != salleLive.prixCarteMax"
                :value="salleLive.prixCarteMax"
                :locale="$i18n.locale + '-CA'"
                currency-code="CAD"
                :subunit-value="true"
              ></money-format>
            </div>
          </div>
        </div>

        <div v-else class="bingo_div_img_pricipal">
          <!-- Salle fermée -->
          <b-card-img-lazy
            :src="jel_getFichierSrc(salle.image)"
            :alt="salle.titre"
            class="bingo_fermer_titre_img bingo_img_principal"
          ></b-card-img-lazy>
        </div>
        <div class="bingo_pastille_row">
          <template v-if="isSalleActive">
            <div class="row bingo_pastille_row_txt mx-0">
              <div class="column col-7 px-0">
                <!-- si la salle ne contient pas de lot progressif -->
                <div
                  v-if="!salleLive.grosLots || salleLive.grosLots.length == 0"
                  class="bingo_color ml-2"
                >
                  <div class="bingo_progressif bingo_progressif_pastille">
                    {{ $t('messageComponent.aucunProgressif') }}
                  </div>
                </div>
                <!--si la salle contient plus d'un progressif -->
                <div v-else-if="salleLive.grosLots.length >= 1" class="ml-2">
                  <div class="bingo_progressif bingo_progressif_pastille">
                    {{ $t('messageComponent.progressif') }} {{ salleLive.grosLots[0].nom }}
                  </div>
                  <div class="bingo_progressif_lot_accueil graphik_bold">
                    <money-format
                      :value="Number(salleLive.grosLots[0].montant)"
                      :locale="$i18n.locale + '-CA'"
                      currency-code="CAD"
                      :subunit-value="true"
                      :hide-subunits="true"
                      class="bingo_prix bingo_color"
                    ></money-format>
                  </div>
                </div>
              </div>
              <div class="column col-5"></div>
            </div>
            <div
              class="bingo_pastille_row_footer graphik_bold"
              :style="{ 'background-color': salle.couleurClair }"
            >
              <div class="row bingo_color justify-content-around h-100">
                <div v-if="isSalleSolo" class="column col-4 bingo_color bingo_icon_wrapper">
                  <img
                    v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_playerSolo.svg`"
                    :alt="$t('messageComponent.nbJoueurs')"
                    class="bingo_icon"
                  />
                  {{ CS_NB_JOUEUR_SOLO }}
                </div>
                <div v-else class="column col-4 bingo_color bingo_icon_wrapper">
                  <img
                    v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_player.svg`"
                    :alt="$t('messageComponent.nbJoueurs')"
                    class="bingo_icon"
                  />
                  {{ salleLive.nombreJoueurs }}
                </div>
                <div
                  v-if="!isSalleSolo"
                  class="column col-4 bingo_color bingo_clock_icon_wrapper"
                >
                  <img
                    v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_clock.svg`"
                    :alt="$t('messageComponent.temps')"
                    class="bingo_icon"
                  />
                  <CompteARebours :dateHeureFin="salleLive.debutTirage"></CompteARebours>
                </div>
                <div class="column col-4 bingo_color bingo_icon_wrapper">
                  <img
                    v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_balls.svg`"
                    :alt="$t('messageComponent.boules')"
                    class="bingo_icon"
                  />
                  {{ salleLive.nombreBoules }}
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <!-- Salle fermée -->
            <div class="bingo_msg_desactivation justify-content-center bingo_color mx-2">
              <div class="graphik_bold">
                {{ messageTitreSalleDesactivation }}
              </div>
              <div class="detail_message_fermeture">{{ messageSousTitreSalleDesactivation }}</div>
            </div>
            <div
              class="bingo_message_heure_ouverture px-2 w-100"
              :style="{ 'background-color': salle.couleurClair }"
            >
              <div class="bingo_color d-flex justify-content-center align-items-center h-100">
                {{ messageRetour }}
                <!-- mis sur UTC peut être changé -->
              </div>
            </div>
          </template>
        </div>
      </div>
    </a>
  </div>

  <!-- ********************** -->
  <!-- ***** Mini-LOBBY ***** -->
  <!-- ********************** -->
  <div
    v-else-if="content.typeAffichage.field === 'lobby'"
    data-component-page="salles.lobby"
    :data-tag="`${jel_getNomRouteCourante()} - ${salle.titre.replace(/&nbsp;/g, ' ')} - ${
      content.dataTag
    }`"
  >
    <div
      v-if="
        (!isSalleCourante &&
          (isSalleActive || content.typeAffichage.forcerAffichage == 'true')) ||
        mixinEnvironnement_inMgnl
      "
      class="h-100 d-flex justify-content-center"
      :class="[isSalleActive ? 'lobby_container' : '']"
    >
      <b-link
        v-if="content.typeAffichage.forcerAffichage == 'true'"
        class="stretched-link"
        :target="getTargetLobby"
        @click="
          if (isSalleActive) {
            launchBingoAndGaq();
          }
        "
      ></b-link>
      <b-link
        v-else
        :to="{ path: '/bingo/lobby', query: { idSalle: content.idSalle } }"
        class="stretched-link"
        replace
        :target="getTargetLobby"
      ></b-link>

      <div
        class="bingo_lobby_card bingo_lobby_card_dimension bingo_lobby_background d-flex flex-column justify-content-between w-100"
        :style="
          'background: linear-gradient(to bottom, #f9ffff, rgba(255,255,255,0) 50%, rgba(0,0,0,0) 70%, black 100%) no-repeat, url(' +
          jel_getFichierSrc(salle.image) +
          ') no-repeat; border-color:' +
          salle.couleurClair +
          ';'
        "
      >
        <b-row class="w-100">
          <b-col cols="4"></b-col>
          <b-col cols="8">
            <div class="bingo_lobby_titre graphik_bold text-right">{{ salle.titre }}</div>
          </b-col>
        </b-row>
        <div v-if="isSalleActive">
          <div class="w-100 text-left bingo_bold bingo_lobby_color lobby_text pl-2">
            <div v-if="salleLive.nomJeu && salleLive.nomJeu != ''">
              {{ $t('messageComponent.jeu') }} {{ salleLive.nomJeu }}
            </div>
            <div v-else>
              {{ $t('messageComponent.nomJeuIndisponible') }}
            </div>

            <span v-if="salleLive.cagnotte && salleLive.cagnotte > 0 && !isSalleSolo"
              >{{ $t('messageComponent.cagnotte') }}
            </span>
            <money-format
              v-if="salleLive.cagnotte && !isSalleSolo"
              :value="salleLive.cagnotte"
              :locale="$i18n.locale + '-CA'"
              currency-code="CAD"
              :subunit-value="true"
              class="bingo_lobby_money_format_price"
            ></money-format>

            <!-- si la salle ne contient pas de lot progressif -->
            <div
              v-if="!salleLive.grosLots || salleLive.grosLots.length == 0"
              class="bingo_lobby_color"
            >
              {{ $t('messageComponent.aucunProgressif') }}
            </div>
            <!-- si la salle contient plus d'un progressif -->
            <div v-else-if="salleLive.grosLots.length >= 1">
              {{ $t('messageComponent.progressif') }} {{ salleLive.grosLots[0].nom
              }}{{ $t('messageComponent.deuxPoints') }}
              <money-format
                :value="Number(salleLive.grosLots[0].montant)"
                :locale="$i18n.locale + '-CA'"
                currency-code="CAD"
                :subunit-value="true"
                :hide-subunits="true"
                class="bingo_lobby_money_format_price"
              ></money-format>
            </div>
          </div>

          <hr class="col-10 lobby_hr" :style="{ color: salle.couleurClair }" />

          <b-card-footer class="bingo_lobby_color pt-0 w-100">
            <div class="d-flex justify-content-around">
              <div v-if="isSalleSolo" class="p-0 d-flex align-items-center lobby_icon_wrapper">
                <div class="d-flex pr-1">
                  <img
                    v-lazy="
                      `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_playerSoloWhite.svg`
                    "
                    :alt="$t('messageComponent.nbJoueurs')"
                    class="bingo_icon_lobby"
                  />
                </div>
                <div>
                  {{ CS_NB_JOUEUR_SOLO }}
                </div>
              </div>
              <div v-else class="p-0 d-flex align-items-center lobby_icon_wrapper">
                <div class="d-flex pr-1">
                  <img
                    v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_playerWhite.svg`"
                    :alt="$t('messageComponent.nbJoueurs')"
                    class="bingo_icon_lobby"
                  />
                </div>
                <div>
                  {{ salleLive.nombreJoueurs }}
                </div>
              </div>

              <div
                v-if="!isSalleSolo"
                class="p-0 d-flex align-items-center lobby_clock_icon_wrapper"
              >
                <div class="d-flex pr-1">
                  <img
                    v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_clockWhite.svg`"
                    :alt="$t('messageComponent.temps')"
                    class="bingo_icon_lobby"
                  />
                </div>
                <div>
                  <CompteARebours :dateHeureFin="salleLive.debutTirage"> </CompteARebours>
                </div>
              </div>
              <div class="p-0 d-flex align-items-center lobby_icon_wrapper">
                <div class="d-flex pr-1">
                  <img
                    v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_ballsWhite.svg`"
                    :alt="$t('messageComponent.boules')"
                    class="bingo_icon_lobby"
                  />
                </div>
                <div>
                  {{ salleLive.nombreBoules }}
                </div>
              </div>
              <div class="p-0 d-flex align-items-center lobby_card_icon_wrapper">
                <div class="d-flex pr-1">
                  <img
                    v-lazy="
                      `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_priceCardWhite.svg`
                    "
                    :alt="$t('messageComponent.prixCarte')"
                    class="bingo_icon_lobby"
                  />
                </div>
                <div>
                  <div class="d-flex justify-content-center">
                    <money-format
                      :value="salleLive.prixCarteMin"
                      :locale="$i18n.locale + '-CA'"
                      currency-code="CAD"
                      :subunit-value="true"
                    ></money-format>
                    <div v-if="salleLive.prixCarteMin != salleLive.prixCarteMax" class="pl-1">
                      -
                    </div>
                  </div>
                  <div v-if="salleLive.prixCarteMin != salleLive.prixCarteMax">
                    <money-format
                      :value="salleLive.prixCarteMax"
                      :locale="$i18n.locale + '-CA'"
                      currency-code="CAD"
                      :subunit-value="true"
                    ></money-format>
                  </div>
                </div>
              </div>
            </div>
          </b-card-footer>
        </div>
        <div v-else class="w-100 text-center bingo_bold bingo_lobby_color lobby_text_fermer mb-4">
          {{ messageTitreSalleDesactivation }}
        </div>
      </div>
    </div>
  </div>

  <!-- ******************************** -->
  <!-- ***** DETAIL (page Salles) ***** -->
  <!-- ******************************** -->
  <div
    v-else-if="content.typeAffichage.field === 'detail'"
    class="pt-2 pb-5"
    data-component-page="salles.page-salles"
    :data-tag="`${jel_getNomRouteCourante()} - ${salle.titre.replace(/&nbsp;/g, ' ')} - ${
      content.dataTag
    }`"
  >
    <b-row class="mx-n2">
      <b-col
        class="col-12 col-md-5 bingo_salle_col_mobile bingo_salle_col_mobile_img_container d-flex flex-column justify-content-md-end"
      >
        <!-- titre -->
        <div class="bingo_affichage_mobile">
          <div class="bingo_detail_titre graphik_bold">{{ salle.titre }}</div>
          <!-- hr thick moitié du titre -->
          <hr class="bingo_detail_underline_titre" :style="{ color: salle.couleurClair }" />
        </div>
        <!-- img dans img description -->
        <div class="bingo_position_relative">
          <p class="bingo_descp_over d-none d-md-block graphik_semibold">{{ salle.slogan }}</p>
          <b-img-lazy
            :src="jel_getFichierSrc(salle.image)"
            :alt="salle.titre"
            class="img-fluid bingo_detail_img_salle"
          ></b-img-lazy>
        </div>
      </b-col>
      <b-col class="col-12 col-md-7 bingo_salle_col_mobile">
        <b-card
          class="bingo_card_corner bingo_card_salle ctn-shadow bingo_card_corner_mobile bingo_card_background overflow-hidden"
        >
          <b-row v-if="isSalleActive" class="bingo_row_height no-gutters w-100">
            <b-col class="col-9 col-xl-10">
              <b-container class="h-100 d-flex flex-column py-0 px-1">
                <b-row class="entete_salle_min_height">
                  <b-col class="col-12 d-flex align-items-center">
                    <!-- si la salle ne contient pas de lot progressif -->
                    <div v-if="!salleLive.grosLots || salleLive.grosLots.length == 0">
                      <div
                        class="bingo_progressif bingo_progressif_salles graphik_semibold"
                        :style="{ color: salle.couleurFonce }"
                      >
                        {{ $t('messageComponent.aucunProgressif') }}
                      </div>
                    </div>
                    <!-- si la salle contient plus d'un lot on affiche uniquement les deux premiers  -->
                    <div v-else>
                      <div
                        v-for="(n, i) in Math.min(
                          salleLive.grosLots.length,
                          nbrProgressifAffichageSalle
                        )"
                        :key="i.id"
                        class="mb-1"
                        :class="[i > 0 ? 'd-none d-md-block' : '']"
                      >
                        <div class="d-flex align-items-center">
                          <div
                            class="bingo_progressif bingo_progressif_salles graphik_semibold"
                            :style="{ color: salle.couleurFonce }"
                          >
                            {{ $t('messageComponent.progressif') }}
                            {{ salleLive.grosLots[i].nom }}
                          </div>
                          <div
                            v-if="
                              i == 0 && salleLive.grosLots.length > nbrProgressifAffichageSalle
                            "
                            class="inline ml-1 autre_lots_container"
                          >
                            <div
                              class="btn_autre_lot"
                              @click="isAfficherAutreLot = !isAfficherAutreLot"
                            >
                              <b-img-lazy
                                :src="`${mixinEnvironnement_damPath}${getPlusIcon}`"
                                alt="Plus"
                                class="h-100 img_autres_lots py-1"
                              >
                              </b-img-lazy>
                              <div v-show="isAfficherAutreLot" class="bingo_autre_lots">
                                <div
                                  v-for="(n, i) in salleLive.grosLots.length -
                                  nbrProgressifAffichageSalle"
                                  :key="i.id"
                                  class="d-flex flex-column text-left pb-1"
                                >
                                  <div class="autre_lots_nom_progressif graphik_semibold">
                                    {{ $t('messageComponent.progressif') }}
                                    {{ salleLive.grosLots[i + nbrProgressifAffichageSalle].nom }}
                                  </div>
                                  <money-format
                                    :value="
                                      Number(
                                        salleLive.grosLots[i + nbrProgressifAffichageSalle]
                                          .montant
                                      )
                                    "
                                    :locale="$i18n.locale + '-CA'"
                                    currency-code="CAD"
                                    :subunit-value="true"
                                    :hide-subunits="true"
                                    class="graphik_bold"
                                  ></money-format>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="bingo_progressif_lot graphik_bold">
                          <money-format
                            :value="Number(salleLive.grosLots[i].montant)"
                            :locale="$i18n.locale + '-CA'"
                            currency-code="CAD"
                            :subunit-value="true"
                            :hide-subunits="true"
                            class="bingo_prix bingo_color"
                          ></money-format>
                        </div>
                      </div>
                    </div>
                  </b-col>

                  <b-col class="bingo_anim_position col-md-3 col-sm-12 d-flex"> </b-col>
                </b-row>
                <hr class="bingo_border_separateur my-1" />
                <b-row class="text-left salle_col_height flex-grow-1">
                  <b-container
                    class="h-100 d-flex justify-content-between flex-column flex-grow-1 py-0"
                  >
                    <div class="ml-2">
                      <ul class="bingo_liste_type_jeu bingo_color">
                        <li v-if="salleLive.nomJeu && salleLive.nomJeu != ''" class="bingo_bold">
                          {{ $t('messageComponent.jeu') }} {{ salleLive.nomJeu }}
                        </li>
                        <li v-else class="bingo_bold">
                          {{ $t('messageComponent.nomJeuIndisponible') }}
                        </li>

                        <li v-if="salleLive.cagnotte && salleLive.cagnotte > 0 && !isSalleSolo">
                          <span class="bingo_bold">{{ $t('messageComponent.cagnotte') }}</span>
                          <money-format
                            :value="salleLive.cagnotte"
                            :locale="$i18n.locale + '-CA'"
                            currency-code="CAD"
                            :subunit-value="true"
                            class="bingo_cagnotte"
                          ></money-format>
                        </li>

                        <li v-else-if="!isSalleSolo">
                          <span class="bingo_bold">{{ $t('messageComponent.cagnotte') }}</span>
                          <money-format
                            :value="0"
                            :locale="$i18n.locale + '-CA'"
                            currency-code="CAD"
                            :subunit-value="true"
                            :hide-subunits="true"
                            class="bingo_cagnotte"
                          ></money-format>
                        </li>
                      </ul>
                      <!-- liste de la description du jeu -->
                      <span
                        class="bingo_color bingo_liste_type_jeu"
                        v-html="salle.description"
                      ></span>
                    </div>

                    <a class="pt-1 pt-md-0" @click="launchBingoAndGaq()">
                      <!-- 'important' à cause d'un style main-bingo qui a un ':hover' qui met le bouton blanc -->
                      <button
                        class="btn bingo_bouton_border btn_detail_hover p-1 graphik_bold mb-0"
                        :style="{ 'background-color': salle.couleurClair + ' !important' }"
                        :data-tag="`${jel_getNomRouteCourante()} - ${salle.titre.replace(
                          /&nbsp;/g,
                          ' '
                        )} - ${content.dataTag}`"
                      >
                        {{ $t('jouer') }}
                      </button>
                    </a>
                  </b-container>
                </b-row>
              </b-container>
            </b-col>

            <b-col class="p-sm-0 py-1 col-3 col-sm-2 offset-sm-1 col-md-3 offset-md-0 col-xl-2">
              <!-- temps personne boule prix de la carte tous un en dessous de lautre -->
              <b-row class="h-100 no-gutters d-flex align-content-center detail_icon_container">
                <div class="bingo_container_info_courte bingo_card_corner card">
                  <div class="card-body h-100 d-flex flex-column justify-content-center">
                    <div class="bingo_salle_detail_icon_placement">
                      <div v-if="isSalleSolo" class="bingo_salle_detail_icon_col">
                        <img
                          v-lazy="
                            `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_playerSolo.svg`
                          "
                          :alt="$t('messageComponent.nbJoueurs')"
                          class="bingo_icon_detail"
                        />
                        <br />
                        <span class="bingo_detail_icon_text">{{ CS_NB_JOUEUR_SOLO }}</span>
                      </div>
                      <div v-else class="bingo_salle_detail_icon_col">
                        <img
                          v-lazy="
                            `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_player.svg`
                          "
                          :alt="$t('messageComponent.nbJoueurs')"
                          class="bingo_icon_detail"
                        />
                        <br />
                        <span class="bingo_detail_icon_text">{{ salleLive.nombreJoueurs }}</span>
                      </div>

                      <div v-if="!isSalleSolo" class="bingo_salle_detail_icon_col">
                        <img
                          v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_clock.svg`"
                          :alt="$t('messageComponent.temps')"
                          class="bingo_icon_detail"
                        />
                        <br />
                        <span class="bingo_detail_icon_text">
                          <CompteARebours :dateHeureFin="salleLive.debutTirage"></CompteARebours>
                        </span>
                      </div>
                      <div class="bingo_salle_detail_icon_col">
                        <img
                          v-lazy="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_balls.svg`"
                          :alt="$t('messageComponent.boules')"
                          class="bingo_icon_detail"
                        />
                        <br />
                        <span class="bingo_detail_icon_text">{{ salleLive.nombreBoules }}</span>
                      </div>
                      <div class="bingo_salle_detail_icon_col">
                        <img
                          v-lazy="
                            `${mixinEnvironnement_damPath}/jel/bingo/icones/icon_priceCard.svg`
                          "
                          :alt="$t('messageComponent.prixCarte')"
                          class="bingo_icon_detail"
                        />
                        <br />
                        <div class="bingo_detail_icon_text">
                          <div class="d-flex justify-content-center">
                            <money-format
                              :value="salleLive.prixCarteMin"
                              :locale="$i18n.locale + '-CA'"
                              currency-code="CAD"
                              :subunit-value="true"
                            ></money-format>
                            <div
                              v-if="salleLive.prixCarteMin != salleLive.prixCarteMax"
                              class="pl-1"
                            >
                              -
                            </div>
                          </div>
                          <div v-if="salleLive.prixCarteMin != salleLive.prixCarteMax">
                            <money-format
                              :value="salleLive.prixCarteMax"
                              :locale="$i18n.locale + '-CA'"
                              currency-code="CAD"
                              :subunit-value="true"
                            ></money-format>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-row>
            </b-col>
          </b-row>

          <!-- Salle désactivée -->
          <b-row v-else class="bingo_row_height no-gutters w-100 h-100">
            <b-col
              cols="12"
              class="bingo_titre_salle d-flex flex-column justify-content-around pr-4"
            >
              <div
                class="container detail_message_fermeture_container text-left my-3 my-md-0 d-flex flex-column align-items-start"
              >
                <div
                  class="detail_message_fermeture_surtitre graphik_bold pb-2"
                  :style="{ color: salle.couleurFonce }"
                >
                  {{ messageTitreSalleDesactivation }}
                </div>
                <div class="detail_message_fermeture">
                  {{ messageSousTitreSalleDesactivation }}
                </div>
              </div>
              <b-card
                class="bingo_message_heure_ouverture_salle"
                :style="{ 'background-color': salle.couleurClair }"
                >{{ messageRetour }}</b-card
              >
            </b-col>
            <div class="ml-3">
              <!-- liste de la description du jeu -->
              <span
                class="bingo_color bingo_liste_type_jeu text-left"
                v-html="salle.description"
              ></span>
              <b-col class="col-12 mt-5 text-left">
                <div
                  class="bingo_liste_type_jeu bingo_color container"
                  v-html="messageDescriptionSalleDesactivation"
                ></div>
              </b-col>
            </div>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</div>
